import React from 'react'
import { useAuthFromContext } from '../AuthContext'

export default function UserBadge() {
  const { userRecord, authStatus, signOut } = useAuthFromContext()

  if (!userRecord) return null

  if (authStatus === 'authenticated') {
    return (
      <div className="user-badge">
        <i className="fa-solid fa-user user-badge__icon user-badge__icon--green" />
        <span className="user-badge__name">{userRecord.displayName}</span>
        <span className="user-badge__sep">·</span>
        <button className="user-badge__action" onClick={signOut}>Sign out</button>
      </div>
    )
  }

  return (
    <div className="user-badge">
      <i className="fa-solid fa-user user-badge__icon" />
      <span className="user-badge__name">Guest</span>
      <span className="user-badge__sep">·</span>
      <button className="user-badge__action" onClick={signOut}>Sign in</button>
    </div>
  )
}
